module.exports = __webpack_public_path__ + "static/media/SellerboxMain02.57a3d058.png";